
import React from "react";
import { useTranslations } from "use-intl";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface PaymentsUnsupportedModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const PaymentsUnsupportedModal: React.FC<PaymentsUnsupportedModalProps> = ({
  open,
  onOpenChange,
}) => {
  const t = useTranslations("consultantPayments.dialogs");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t("unsupportedTitle")}</DialogTitle>
          <DialogDescription>{t("unsupportedBody")}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>{t("gotIt")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentsUnsupportedModal;
